
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","width":"20","height":"20","data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.39 10.96"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_1-2","fill":"#2b938c","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"Mắt"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M8.7 0C4.62 0 1.06 2.18.03 5.29c-.04.12-.04.27 0 .39 1.03 3.12 4.59 5.28 8.66 5.28s7.64-2.17 8.66-5.28c.03-.12.03-.27 0-.39C16.34 2.18 12.76 0 8.7 0zm0 9.59c-2.27 0-4.11-1.84-4.11-4.11s1.84-4.1 4.11-4.1 4.1 1.83 4.1 4.1-1.83 4.11-4.1 4.11z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M11.39 5.48c0 1.5-1.21 2.7-2.69 2.7s-2.69-1.21-2.69-2.7c0-.29.04-.57.13-.83.21.21.52.36.86.36.67 0 1.22-.55 1.22-1.23 0-.33-.13-.64-.36-.86a2.697 2.697 0 013.53 2.56z"}})])])])
          )
        }
      }
    